export const DownArrow = () => <span className="arrow">&#x25BC;</span>;
export const UpArrow = () => <span className="arrow">&#9650;</span>;
export const RightArrow = () => <span className="arrow">&#x25B6;</span>;
